export default {

  LOAD_MEMBERS (state, data) {
    state.list = data.data
    state.listInfo = data
  },

  LOAD_MEMBERS_ALL (state, data) {
    state.listAll = data.data
  },

  LOAD_MEMBER (state, data) {
    state.memberInfo = data
  },

  LOAD_MEMBER_DETAIL (state, data) {
    state.memberInfo = data
  },

  REGISTER_MEMBER (state, data) {
    state.memberInfo = data
  },

  MODIFY_MEMBER (state, data) {
    state.memberInfo = data
  },

  SET_META (state, data) {
    const _meta = JSON.parse(JSON.stringify(state.meta))
    if (data.key) {
      const response = data.response
      if (response && response.length > 0) {
        // 같은 key 로 여러개 등록된 경우, 마지막 것만 사용
        const meta = response[response.length - 1]
        try {
          _meta[data.key] = JSON.parse(meta.meta_value)
        } catch (err) {
          _meta[data.key] = undefined
        }
      }
    }
    state.meta = _meta
  },

  SET_META_ALL (state, data) {
    const _meta = JSON.parse(JSON.stringify(state.meta))
    if (data && data.length > 0) {
      for (const meta of data) {
        try {
          _meta[meta.meta_key] = JSON.parse(meta.meta_value)
        } catch (err) {
          _meta[meta.meta_key] = undefined
        }
      }
    }
    state.meta = _meta
  }
}
